import * as React from 'react'
import { DateRangePickerSeeker } from 'ui-seeker/core'
import { isAfter } from 'ui-seeker/utils'

export default function DatePrevRangeSelect({...props}) {

	const myProps = {
		disabledDate: date => isAfter(date), 
		...props
	}

    return <DateRangePickerSeeker {...myProps} />
}